<template>
  <div class="container">
    <div class="regard-home">
      <div class="regard-home-content regard-home-content-1">
        <div class="l-regard-view l-regard-view-1">
          <span class="l-rv-title">一群有义有情的人在一起</span>
          <div class="l-rv-content">做一件有意义伟大的事业</div>
        </div>
      </div>
      <div class="video-box">
        <video
          data-v-bde1585c=""
          autoplay="autoplay"
          controls="controls"
          loop="loop"
          src="https://bopin.oss-cn-shenzhen.aliyuncs.com/video.mp4"
        ></video>
      </div>
      <div>
        <div class="container">
          <div class="regard-home-content regard-home-content-2">
            <div class="l-regard-view l-regard-view-2">
              <h3 class="l-regard-view-title">播聘简介</h3>
              <div class="l-r-v-list">
                <div class="l-r-v-item" v-for="(s, i) in intr" :key="i">
                  {{ s.title }}
                </div>
              </div>
            </div>
          </div>

          <div class="regard-home-content regard-home-content-3">
            <div class="l-regard-view l-regard-view-3">
              <div class="l-regard-content">
                <h3 class="l-rc-title">播聘集团</h3>
                <div data-v-e97f86d2="" class="l-rc-content">
                  <div
                    data-v-e97f86d2=""
                    class="l-rc-content-list l-rc-content-line"
                  >
                    <h5 data-v-e97f86d2="" class="l-rc-cl-title">愿景</h5>
                    <div data-v-e97f86d2="" class="l-rc-cl-view">
                      站在用工模式最前沿 释放每个人的价值
                    </div>
                  </div>
                  <div data-v-e97f86d2="" class="l-rc-content-list">
                    <h5 data-v-e97f86d2="" class="l-rc-cl-title">使命</h5>
                    <div data-v-e97f86d2="" class="l-rc-cl-view l-rc-cl-view-1">
                      打造诚信、高效、专业的 一站式招聘服务平台
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="regard-home-content regard-home-content-4">
            <div class="l-regard-view l-regard-view-4">
              <h3 class="l-regard-view-title">使命价值观</h3>
              <div class="l-regard-list">
                <div class="l-regard-item" v-for="(s, i) in list" :key="i">
                  <div class="l-regard-list-pad">
                    <h4 class="l-regard-item-title">{{ s.title }}</h4>
                    <h5 class="l-regard-item-sub-title">{{ s.sub_title }}</h5>
                    <div class="l-regard-item-content">
                      <div
                        class="l-regard-item-list"
                        v-for="(item, key) in s.list"
                        :key="key"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-regard-list l-regard-list-1">
                <div class="l-regard-item" v-for="(s, i) in list1" :key="i">
                  <div class="l-regard-list-pad">
                    <h4 class="l-regard-item-title">{{ s.title }}</h4>
                    <h5 class="l-regard-item-sub-title">{{ s.sub_title }}</h5>
                    <div class="l-regard-item-content">
                      <div
                        class="l-regard-item-list"
                        v-for="(item, key) in s.list"
                        :key="key"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyIntr",
  data() {
    return {
      intr: [
        {
          title:
            "5G时代，求职招聘就用播聘! 播聘是中国5G时代高效的一站式视频招聘服务平台。"
        },
        {
          title:
            " 面向广大求职者，播聘提供安全、丰富的全职与兼职工作信息，并通过产品创新与服务保障，为用户打造了更加良好的求职体验，帮助求职者快速找到 合适岗位。“5G时代, 求职招聘就用播聘” 不只是一句口号，更是播聘产品所秉承的服务愿景"
        },
        {
          title:
            "针对企业，播聘提供的在线招聘服务，覆盖多种类型岗位，帮助客户快捷方便的高效招聘。并提供包括视频招聘、RPO招聘服务、网络视频培训等系列 增服务，同时，针对个人需求, 播聘提供短时工等信息以解决用户需求"
        },
        {
          title:
            "通过海量人才库数据，播聘进行智能筛选，可提供更有保障的招聘效果与更加透明、高效的管理服务，帮助企业从根本上解决招人难、用工隐性成本高 等问题。"
        },
        {
          title:
            " 截止目前，播聘业务已覆盖餐饮酒店、零售快消、互联网、物流快递、教育培训、展览展会等诸多服务行业，服务范围超过300个城市。"
        }
      ],
      list: [
        {
          title: "感恩",
          sub_title: "用户第一 心怀感恩",
          list: [
            {
              title:
                "斗米之恩，心必念之：用户第一，走近用户，充分了解用户，为用户创造 最大价值 "
            },
            {
              title:
                "感恩公司，共同成长：具有主人翁意识，随时随地维护公司形象，在尊重 用户的前提之下，达成公司和用户利益的均衡 "
            },
            {
              title:
                "感谢伙伴，共担共享：积极融入团队，具有开放共赢心态，善于利用团队 的力量解决问题和困难"
            }
          ]
        },
        {
          title: "正直",
          sub_title: "坚行正道 言行坦荡",
          list: [
            {
              title:
                "厚德载物，以德为先：坚持正心做事、正念为人，坚守正道，用正直的力量 积极影响我们周围的人"
            },
            {
              title: "心胸坦荡，言行一致，言出必践，直言而有讳"
            },
            {
              title:
                "公平公正，客观评价团队：主动担当，不委过于人；清正廉洁，严格遵守 职业操守"
            }
          ]
        }
      ],
      list1: [
        {
          title: "创新",
          sub_title: "打破常规 不懈探索",
          list: [
            {
              title: "创新的核心目的是为用户创造价值 "
            },
            {
              title:
                "敏锐预见用户与市场的变化，打破常规、营造人人事事皆可创新的氛围"
            },
            {
              title: "不懈探索，敢于突破，勇于尝试，不惧失败，善于总结"
            }
          ]
        },
        {
          title: "尽责",
          sub_title: "专业执着 精益求精",
          list: [
            {
              title:
                "有强烈的使命感，成就驱动，勇于承担责任，主动迎接新的任务和挑战 "
            },
            {
              title: "热爱公司，全身心投入，尽职尽责，极致执行，追求卓越 "
            },
            {
              title:
                "保持好奇心，坚持钻研、持续学习、不断提高专业水平与职业能力"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped="scoped">
@import url("./company-intr.css");
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue